import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import { canViewOptimiser } from 'library/optimiser';
import config from './config';

const getConfig = () => {
  const optimiserEnabled = canViewOptimiser();
  if (optimiserEnabled) return config;

  return {
    ...config,
    list: {
      ...config.list,
      columns: config.list.columns.filter(col => col.dataIndex !== 'used_by_optimiser')
    }
  };
};

const Tags = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminTags()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.tag,
      list: REDUCER_KEY.tags
    }}
    config={getConfig()}
    permissions={permissions}
  />
);

Tags.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default Tags;
